export default __webpack_public_path__ + "static/footerlogo-d45bc2dd2c0de240e8afa25e97a45665.png";